export default __webpack_public_path__ + "static/real5-998c82063c5c85b9181e728d182eff68.png";